import { Skill, SkillResource } from './Skills';

export const transformToSkill = (
    skillResource: SkillResource,
): Skill => ({
    id: skillResource.id,
    escoUuid: skillResource.escoUuid,
    name: skillResource.name,
});
